import React, { FC } from 'react'
import classNamesBind from 'classnames/bind'

import css from './styles.module.scss'
const classNames = classNamesBind.bind(css)

interface OwnProps {
  dark?: boolean
  height: number
  margin: string
  radius?: string
  width: string
  zIndex?: number
}

const LoadingBar: FC<OwnProps> = ({
  dark,
  height,
  margin,
  radius,
  width,
  zIndex,
}: OwnProps) => {
  return (
    <div
      className={classNames('container', { dark })}
      style={{
        height: `${height}px`,
        margin,
        minWidth: width,
        width,
        zIndex: zIndex ? zIndex : 0,
        borderRadius: radius || '4px',
      }}
    />
  )
}

export default LoadingBar
